import { useState } from "react";
import { Table } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/styles/customTable.scss";
import useColumnResize from "../../hooks/useColumnResize";

/**
 * Zwraca kolor badge na podstawie typu akcji
 */
const getActionBadgeColor = (actionId) => {
  switch (actionId) {
    case 1:
      return "danger";    // Błąd
    case 2:
      return "warning";   // Ostrzeżenie
    case 3:
      return "info";      // Informacja
    default:
      return "light";
  }
};

const AuditLogTable = ({ data, onSortChange }) => {
  const [sortConfig, setSortConfig] = useState({ key: "Date", direction: "desc" });
  const { getResizeProps } = useColumnResize();

  const items = Array.isArray(data) ? data : [];

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    const newSortConfig = { key, direction };
    setSortConfig(newSortConfig);
    onSortChange(newSortConfig);
  };

  const getSortArrow = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "asc" ? "↑" : "↓";
    }
    return "";
  };

  return (
    <div>
      <Table responsive striped bordered hover size="sm" className="custom-table">
        <thead>
          <tr>
            <th onClick={() => requestSort("Date")} {...getResizeProps()}>
              Data {getSortArrow("Date")}
            </th>
            <th onClick={() => requestSort("Action")} {...getResizeProps()}>
              Akcja {getSortArrow("Action")}
            </th>
            <th onClick={() => requestSort("UserLogin")} {...getResizeProps()}>
              Użytkownik {getSortArrow("UserLogin")}
            </th>
            <th onClick={() => requestSort("Description")} {...getResizeProps()}>
              Opis {getSortArrow("Description")}
            </th>
          </tr>
        </thead>
        <tbody>
          {items.length > 0 ? (
            items.map((item, index) => (
              <tr key={`${item.id}-${index}`}>
                <td>{item.date}</td>
                <td>
                  <span className={`badge bg-${getActionBadgeColor(item.actionId)}`}>
                    {item.action}
                  </span>
                </td>
                <td>{item.userLogin}</td>
                <td style={{ maxWidth: "500px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {item.description}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" className="text-center">
                Brak danych
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default AuditLogTable;
